import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { ChipIcon } from "../icons/ChipIcon";

interface props {
  setAnswer: (answer: string) => void;
  timesOfAnswers: number;
  setTimesOfAnswers: (timesOfAnswers: number) => void;
  setIsMistaken: (isMistaken: boolean) => void;
  isShown: boolean;
  theme: string;
  lostChars: string[];
  charsWithoutChip: string[];
}

const Board: React.FC<props> = ({
  setAnswer,
  timesOfAnswers,
  setTimesOfAnswers,
  setIsMistaken,
  isShown,
  theme,
  lostChars,
  charsWithoutChip,
}) => {
  const charsList = [
    ["わ", "ら", "や", "ま", "は", "な", "た", "さ", "か", "あ"],
    ["を", "り", "", "み", "ひ", "に", "ち", "し", "き", "い"],
    ["ん", "る", "ゆ", "む", "ふ", "ぬ", "つ", "す", "く", "う"],
    ["ー", "れ", "", "め", "へ", "ね", "て", "せ", "け", "え"],
    ["", "ろ", "よ", "も", "ほ", "の", "と", "そ", "こ", "お"],
  ];

  const [charsWithChip, setCharsWithChip] = useState(
    charsList.flat().filter((char) => !charsWithoutChip.includes(char))
  );
  const clickChar = (char: string) => {
    setTimesOfAnswers(timesOfAnswers + 1);
    setCharsWithChip([...charsWithChip, char]);
    if (lostChars.includes(char)) {
      setAnswer(char);
    } else {
      setIsMistaken(true);
      setTimeout(() => {
        setIsMistaken(false);
      }, 1000);
    }
  };

  const isWithChip = (char: string) => charsWithChip.includes(char);

  const [boardWidth, setBoardWidth] = useState<number>(0);

  const getBoardWidth = () => {
    const el = document.getElementById("board");
    setBoardWidth(el?.getBoundingClientRect().width || 0);
  };

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      getBoardWidth();
      window.addEventListener("resize", getBoardWidth);
      return () => window.removeEventListener("resize", getBoardWidth);
    }

    return;
  }, []);

  return (
    <Box
      id="board"
      maxWidth="800px"
      bgcolor="#E80010"
      borderRadius={4}
      sx={{
        width: { xs: "90%", md: "100%" },
      }}
    >
      <Box //といえば、の下の線とか
        width="94%"
        display="flex"
        color="white"
        borderBottom={4}
        ml="auto"
        mr="auto"
        fontFamily="yasashisa"
        sx={{ fontSize: { xs: 20, md: 28 } }}
      >
        <Box
          width="30%"
          minWidth="140px"
          bgcolor="white"
          borderRadius={5}
          flexDirection={"row"}
          style={{ color: "black", display: "flex", justifyContent: "center" }}
          sx={{
            my: { xs: 1, md: 2 },
            fontSize: { xs: 14, md: 28 },
          }}
        >
          {isShown && theme}
        </Box>
        <Box
          sx={{
            ml: { xs: "4px", md: 1 },
            my: { xs: 1, md: 2 },
            fontSize: { xs: 14, md: 28 },
          }}
        >
          {/*フォント変えたい*/}
          といえば
        </Box>
      </Box>
      <Box
        ml="auto"
        mr="auto"
        width="98%"
        sx={{
          my: { xs: 1 },
          mt: { md: 2 },
          mb: { md: 3 },
        }}
      >
        {charsList.map((chars, index) => {
          return (
            <Box display="flex" justifyContent="center" key={index}>
              {chars.map((char, i) => {
                return (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width={boardWidth / 10 - 5} //一般的な調整方法？高さも調整したい？
                    minWidth="30px"
                    maxHeight="90px"
                    borderBottom={
                      index === charsList.length - 1 ? 0 : "1px solid #ccc"
                    }
                    borderRight={i === chars.length - 1 ? 0 : "1px solid #ccc"}
                    style={{
                      cursor: isWithChip(char) ? "not-allowed" : "pointer",
                    }}
                    onClick={() =>
                      !isWithChip(char) && !isShown && clickChar(char)
                    }
                    sx={{
                      height: { md: boardWidth / 10 },
                    }}
                    key={i}
                  >
                    {isWithChip(char) ? (
                      <ChipIcon
                        width="90%"
                        style={{
                          minWidth: "28px",
                          maxWidth: "90px",
                          maxHeight: "90px",
                        }}
                      />
                    ) : (
                      <Box
                        fontFamily="yasashisa"
                        sx={{
                          color: "white",
                          fontSize: { xs: 22, md: 40 },
                        }}
                      >
                        {char}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Board;
